<template>
  <b-container fluid id="advanced-settings">
    <b-row no-gutters>
      <b-col>
        <DesignNav></DesignNav>
      </b-col>
      </b-row>    
    <b-row no-gutters>
      <b-col>
        <transition name="fade">
          <b-alert
            v-model="isShowSaveAlert"
            class="rounded-0 border-0 text-white d-flex flex-column flex-md-row justify-content-between align-items-center"
            id="save-alert"
          >
            <p class="mb-0">There are unsaved changes on this page.</p>
            <div class="alert-action-buttons">
              <b-button variant="ghost" @click="hideSaveAlert" :disabled="isSaving">Cancel</b-button>
              <b-button pill variant="primary" @click="handleSave" :disabled="isSaving">{{ isSaving ? 'Saving...' : 'Save Changes' }}</b-button>
            </div>
          </b-alert>
        </transition>
      </b-col>
    </b-row>
    <b-row class="p-4 px-5">
      <b-container fluid class="pb-4">
        <b-link
          v-for="(tab, key) in formattedTabs"
          :key="key"
          :to="{ name: tab.route }"
          class="tab-link"
          exact
          exact-active-class="active-tab-link"
        >
          {{ tab.label }}
        </b-link>
      </b-container>
      <router-view />
    </b-row>
  </b-container>
</template>

<script>
import DesignNav from "@/views/design/components/DesignNav";
import { mapGetters } from "vuex";
import { subscriptionChannels } from "@/mixins/subscription_channels";

export default {
  name: "advancedSettings",
  components: {
    DesignNav
  },
  data() {
    return {
      isShowSaveAlert: false,
      tabs: [
        {
          label: "Icons & Logos",
          route: "designAdvancedSettingsIconsAndLogos",
        },
        {
          label: "Snippet Details",
          route: "designAdvancedSettingsSnippetDetails",
        },
        {
          label: "Order Status",
          route: "designAdvancedSettingsOrderStatus",
        },
        {
          label: "Web Sequence",
          route: "designAdvancedSettingsWebSequence",
        },
        {
          label: "About Us",
          route: "designAdvancedSettingsAboutUs",
        },
        {
          label: "Categories",
          route: "designAdvancedSettingsCategories",
        },
        {
          label: "Our Brands",
          route: "designAdvancedSettingsOurBrands",
        },
      ],
      storedToRoute: null
    };
  },
  mixins: [subscriptionChannels],
  computed: {
    ...mapGetters({
      isSaving: "designs/saving",
      planChannels: "accountProfile/planChannels"
    }),
    formattedTabs: {
      get() {
        const filter_glife_tabs = ['Icons & Logos', 'Order Status'];
        if (this.isGlifeOnly()) {
          return filter_glife_tabs.map(glifeTab => {
            return this.tabs.filter(tab => tab.label === glifeTab);
          }).flat();
        } else return this.tabs;
      },
      set(tabs) {
        return tabs;
      }
    }
  },
  mounted() {
    this.$root.$on('showSaveAlert', (value) => {
      this.isShowSaveAlert = value;
    });
  },
  beforeDestroy() {
    this.$root.$off('showSaveAlert');
  },
  methods: {
    hideSaveAlert() {
      this.$root.$emit('saveChangesCancelled', true);
      this.isShowSaveAlert = false;
    },
    handleSave() {
      this.$root.$emit('handleSave', this.$route.name);
    }
  }
};
</script>

<style lang="scss" scoped>
#save-alert {
  background: #2F4858;
  .alert-action-buttons .btn-primary {
    border-radius: 20px;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>